import { Controller } from "@hotwired/stimulus"

// Live mirror of the server-side password policy (issue #670 /
// PasswordComplexityValidatable). Each rule below maps to one checklist item
// rendered in the signup form; as the user types we toggle the item between a
// "met" and "unmet" state. This is purely visual feedback — the server stays
// the single source of truth and re-validates on submit.
//
// Item markup contract (see devise/registrations/new.html.erb):
//   <li data-password-requirements-target="item" data-rule="length">
//     <iconify-icon data-password-requirements-target="icon" ...></iconify-icon>
//     <span>...</span>
//   </li>
export default class extends Controller {
  static targets = ["input", "item", "icon"]

  // Mirrors PasswordComplexityValidatable::SPECIAL_CHARACTER and the
  // Devise config.password_length minimum (10).
  static RULES = {
    length: (v) => v.length >= 10,
    uppercase: (v) => /[A-Z]/.test(v),
    lowercase: (v) => /[a-z]/.test(v),
    digit: (v) => /\d/.test(v),
    special: (v) => /[!@#$%^&*()_\-+=\[\]{}|\\:;"'<>,.?/~`]/.test(v),
  }

  connect() {
    this.update()
  }

  update() {
    const value = this.hasInputTarget ? this.inputTarget.value : ""

    this.itemTargets.forEach((item) => {
      const rule = item.dataset.rule
      const test = this.constructor.RULES[rule]
      if (!test) return

      const met = test(value)
      item.classList.toggle("password-requirements__item--met", met)
      item.setAttribute("aria-checked", met ? "true" : "false")

      const icon = item.querySelector("[data-password-requirements-target='icon']")
      if (icon) {
        icon.setAttribute(
          "icon",
          met ? "solar:check-circle-bold" : "solar:circle-linear"
        )
      }
    })
  }
}
